import useAccount from 'hooks/use-account';
import { FormProvider, useForm } from 'react-hook-form';
import { namespaces } from '../AccountForm';
import { Programs } from '../AccountForm/Programs/Programs';
import styles from './AccountPrograms.module.scss';

const AccountPrograms = () => {
    const {
        account: { features }
    } = useAccount();

    const enrolledInAgentMatchProgram = Boolean(features?.agentMatch_2024);

    const methods = useForm({
        mode: 'onBlur',
        reValidateMode: 'onChange',
        defaultValues: { [namespaces.PROGRAM]: { agentMatch_2024: enrolledInAgentMatchProgram } }
    });

    const { handleSubmit } = methods;

    const addPrograms = async (values) => {
        // TODO: Currently only able to add program on creation
    };

    if (!enrolledInAgentMatchProgram) {
        return null;
    }

    return (
        <div className={styles.accountPrograms}>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit(addPrograms)}>
                    <Programs namespace={namespaces.PROGRAM} formDisabled />
                </form>
            </FormProvider>
        </div>
    );
};

export { AccountPrograms };
